var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpdateIllustration(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3552_59422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M63.4125 103.372C87.4127 103.372 106.87 83.9143 106.87 59.8285C106.87 35.7428 87.327 16.2856 63.4125 16.2856C39.4125 16.2856 19.9553 35.7428 19.9553 59.8285C19.9553 83.9143 39.4125 103.372 63.4125 103.372Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.041 31.2859C105.982 31.2859 107.555 29.7125 107.555 27.7716C107.555 25.8307 105.982 24.2573 104.041 24.2573C102.1 24.2573 100.527 25.8307 100.527 27.7716C100.527 29.7125 102.1 31.2859 104.041 31.2859Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.6856 21.7116C98.0108 21.7116 99.0856 20.6371 99.0856 19.3116C99.0856 17.9861 98.0108 16.9116 96.6856 16.9116C95.3596 16.9116 94.2856 17.9861 94.2856 19.3116C94.2856 20.6371 95.3596 21.7116 96.6856 21.7116Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2699 31.1999C23.5954 31.1999 24.6699 30.1254 24.6699 28.7999C24.6699 27.4744 23.5954 26.3999 22.2699 26.3999C20.9444 26.3999 19.8699 27.4744 19.8699 28.7999C19.8699 30.1254 20.9444 31.1999 22.2699 31.1999Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1714 83.0813C14.633 83.0813 16.6285 81.0858 16.6285 78.6241C16.6285 76.1625 14.633 74.167 12.1714 74.167C9.70974 74.167 7.71423 76.1625 7.71423 78.6241C7.71423 81.0858 9.70974 83.0813 12.1714 83.0813Z",
    fill: "#EAEEF9"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3552_59422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M109.663 79.2248H96.4792C95.8552 79.2248 95.3212 78.8239 95.143 78.2894C93.8512 74.459 91.0004 73.5237 84.0971 70.8067C83.6962 70.6285 83.6517 70.0941 84.0526 69.8714C86.0569 68.8915 85.7006 68.0453 85.7006 62.1659C85.6114 62.0769 85.5224 61.9433 85.4778 61.8542C85.0324 61.1861 84.7207 60.3844 84.6316 59.5827L84.1862 59.3599C82.85 59.6717 82.939 58.2465 82.5827 55.4849C82.4491 54.3269 82.6273 54.1043 83.1172 53.9261L83.5626 53.3471C80.9348 47.4677 82.271 43.771 84.8543 42.4348C84.0081 40.5641 83.9635 39.896 83.9635 39.896C83.9635 39.896 89.4421 40.8313 91.3124 40.4304C93.7175 39.9405 97.3698 40.5196 98.7507 43.6819C101.022 44.5727 101.913 46.0425 102.136 47.5569C102.448 50.0511 101.067 52.7681 100.799 53.837C100.844 53.8816 100.844 53.9261 100.888 53.9706C101.245 54.1487 101.379 54.4606 101.245 55.4405C100.933 58.0683 100.978 59.7162 99.6412 59.3154L98.4387 61.4088C98.3941 61.676 98.3495 61.7651 98.3495 61.8987C98.305 62.2996 98.305 63.0568 98.305 67.4217C98.305 67.9562 98.4387 68.4461 98.7061 68.8469C98.9735 69.3369 99.4192 69.6932 99.9532 69.9159H99.9978C103.115 71.2076 105.343 72.0539 106.99 72.7219C110.643 74.1917 111.267 74.5926 111.579 77.0423C111.667 78.2449 110.821 79.2248 109.663 79.2248Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M100.71 53.7921C100.843 53.1239 100.531 52.3222 100.265 51.7432C100.22 51.6541 100.176 51.565 100.131 51.4314C99.106 49.338 96.7454 48.4473 94.5185 48.3581C88.8177 48.0464 88.2828 49.1599 86.5017 47.5119C87.0357 48.3581 87.1248 49.6498 86.2342 51.2978C85.6553 52.4559 84.4972 52.9458 83.4728 53.3021C80.8895 47.4228 82.1812 43.726 84.7645 42.3898C83.9182 40.5191 83.8737 39.8511 83.8737 39.8511C83.8737 39.8511 89.3525 40.7864 91.2228 40.3855C93.628 39.8956 97.2802 40.4746 98.6611 43.6369C100.933 44.5277 101.823 45.9976 102.046 47.5119C102.403 50.0062 100.977 52.723 100.71 53.7921Z",
    fill: "url(#paint0_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M108.281 79.224C109.662 77.0861 109.127 75.0818 106.9 72.7212C110.552 74.191 111.175 74.5918 111.487 77.0415C111.666 78.1551 110.775 79.1795 109.617 79.1795H108.281V79.224Z",
    fill: "#9AA2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.6164 68.8911V69.9155H85.3878V68.5793C85.6996 67.8667 85.6105 67.9112 85.6105 62.1656C85.5214 62.0765 85.4324 61.9429 85.3878 61.8538V61.542C85.6551 62.0319 86.056 62.4774 86.4569 62.8337L90.5986 65.7288C91.5792 66.5305 92.9592 66.575 93.9398 65.7734L97.8141 62.2992C97.9478 62.1656 98.0815 62.0765 98.2152 61.9429C98.1706 62.3438 98.1706 63.101 98.1706 67.4659C98.2152 67.9558 98.3489 68.4458 98.6164 68.8911Z",
    fill: "url(#paint1_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_3552_59422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.5161 69.2917C39.3782 69.2473 39.1555 68.8464 39.1555 68.8464V65.2831C41.4271 63.4125 43.3423 61.2301 43.8768 58.3795C45.302 58.0677 46.1928 56.776 46.0592 55.3507C46.0147 54.7272 45.6138 54.1482 45.5693 53.4801C45.5693 53.1683 45.5693 52.8565 45.5693 52.5447C45.5693 52.322 45.5693 52.1439 45.5247 51.9211C45.5247 51.6985 45.4801 51.4758 45.4801 51.2531C45.3465 50.1841 45.0793 49.0706 44.3667 47.779C42.585 44.4385 39.0664 42.2114 35.1024 42.2114C34.3007 42.2114 33.4989 42.3006 32.7417 42.4787C31.3164 42.7905 30.0248 43.414 28.8667 44.3048C28.644 44.483 28.4214 44.6611 28.1987 44.8393C28.1541 44.8838 28.1096 44.9284 28.0205 44.973C26.7734 46.131 25.7935 47.6008 25.259 49.2487C24.7245 50.8968 24.591 52.5893 24.8137 54.2818C24.8137 54.3264 24.8137 54.3709 24.8137 54.4154C24.8137 54.4599 24.8137 54.5045 24.8137 54.5491C24.8581 54.8608 24.9473 54.8163 24.7245 55.0835C24.68 55.1726 24.591 55.2617 24.5464 55.3953C24.2791 55.8853 24.0564 56.5533 24.3682 57.3551C24.9027 58.8694 25.9717 58.6467 26.9515 59.493C26.907 59.5375 26.8179 59.582 26.7734 59.582H26.7289L25.6153 59.9383C18.9343 62.0317 18.1771 69.1136 25.0363 70.4053C24.5464 70.4498 24.101 70.717 23.7892 70.9398C21.6067 72.6323 20.226 75.2155 19.8696 77.7543C19.7361 78.5115 20.3596 79.2241 21.1614 79.2241H31.7618C31.9846 79.2241 32.2073 79.046 32.2963 78.8233C33.2762 75.2601 35.5032 74.013 40.1353 72.1423L42.8077 71.0733C43.2532 70.8952 43.7431 70.717 44.2776 70.4943C44.7675 70.3162 44.723 69.6036 44.1885 69.4699C43.654 69.3363 43.1196 69.2917 42.5851 69.2473C42.1397 69.2917 41.7834 69.2917 41.5161 69.2917ZM27.9314 64.7487C27.9314 64.3033 28.2432 63.8133 28.9113 63.2789C29.1786 63.6352 29.5349 64.0361 29.9358 64.3924C30.2475 64.6596 30.5593 64.9268 30.9156 65.1941C31.1383 65.3277 31.361 65.5058 31.5837 65.684C31.6283 65.7286 31.6728 65.7731 31.7173 65.7731C31.7618 65.8177 31.851 65.8621 31.8955 65.9067V68.0892C31.851 68.0446 31.8064 68.0001 31.7618 68.0001C31.5391 67.8219 31.361 67.6438 31.1828 67.5102C30.8711 67.2875 30.5593 67.1093 30.2475 66.9312C30.1139 66.842 30.0248 66.7975 29.9358 66.7084C28.9113 66.0403 27.976 65.4168 27.9314 64.7487Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M41.5152 69.2919C41.1589 70.5836 40.758 71.3853 40.758 71.3853L29.2667 69.5591L29.9348 66.7086C30.0239 66.7977 30.1575 66.8422 30.2466 66.8867C30.5584 67.0649 30.9147 67.2876 31.1819 67.5103C31.3601 67.6439 31.5828 67.7775 31.7609 68.0002C31.8055 68.0448 31.85 68.0893 31.85 68.0893V65.9068C31.7609 65.8623 31.7164 65.8178 31.6719 65.7733C33.5426 66.7086 35.8586 67.1985 39.1991 65.2388C39.1546 65.2388 39.1546 65.2833 39.1101 65.2833V68.8465C39.1101 68.8465 39.3772 69.2474 41.5152 69.2919Z",
    fill: "url(#paint2_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.4798 51.921C43.5646 52.5891 41.5158 52.8563 39.4669 52.6782C36.26 52.4109 33.1422 51.1193 30.7371 48.9813C29.9353 51.2974 27.9311 53.0345 25.6595 54.059C25.3477 54.1925 25.036 54.3261 24.7242 54.4153C24.7242 54.3707 24.7242 54.3261 24.7242 54.3261C24.5015 52.6336 24.6351 50.9411 25.1695 49.2932C25.704 47.6451 26.6839 46.1754 27.9311 45.0173C27.9756 44.9727 28.0201 44.9283 28.1092 44.8837C28.3319 44.7056 28.5546 44.5274 28.7773 44.3493C29.9353 43.503 31.2715 42.8794 32.6523 42.5231C33.454 42.3449 34.2112 42.2559 35.0129 42.2559C38.977 42.2559 42.4956 44.4828 44.2772 47.8233C44.9453 49.115 45.2571 50.2285 45.3907 51.2529C45.4798 51.4756 45.4798 51.6983 45.4798 51.921Z",
    fill: "url(#paint3_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0441 63.4126C29.3113 63.7689 29.6231 64.0807 29.8903 64.348C29.5786 64.0807 29.2668 63.7689 29.0441 63.4126Z",
    fill: "#3973F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2304 74.6811C32.3841 75.7501 30.7807 75.7946 29.4445 75.7501C30.8697 74.3693 30.0681 69.8707 25.0796 70.4053H25.035C18.1759 69.1136 18.9331 62.0317 25.5695 59.9383L26.683 59.582C26.7721 59.6266 26.8167 59.6712 26.8611 59.7602C27.3957 61.1409 28.1083 62.299 28.8655 63.2343C26.1485 65.5058 29.9344 66.2185 31.7606 67.9555C33.364 68.8909 34.7002 72.8104 33.2304 74.6811Z",
    fill: "url(#paint4_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9992 63.4124C28.9547 63.3679 28.9102 63.3234 28.9102 63.2788C28.9102 63.2788 28.9547 63.3679 28.9992 63.4124Z",
    fill: "#3973F4"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_3552_59422)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.6037 81.2731C92.8266 82.9211 91.5349 84.4354 89.842 84.4354H37.6413C35.9488 84.4354 34.6572 82.9211 34.8799 81.2731C35.3698 77.8436 36.127 77.1309 41.2046 75.082L42.4516 74.5921C44.8123 73.6568 47.8856 72.4988 52.0277 70.7617C52.9631 70.3608 53.7203 69.6482 54.1211 68.7128C54.3438 68.2229 54.4774 67.6439 54.4774 67.0649V59.2704C54.3438 59.0922 54.2102 58.9586 54.1211 58.7804C53.4531 57.8006 53.0076 56.6425 52.874 55.3954L52.2059 55.0836C50.2017 55.5735 50.3798 53.4356 49.8453 49.338C49.6226 47.6455 49.8898 47.2892 50.647 47.0219L51.2706 46.1756C47.4401 37.4903 49.3554 32.0564 53.1412 30.1412C51.9832 27.3798 51.8942 26.3999 51.8942 26.3999C51.8942 26.3999 59.9559 27.7361 62.7173 27.2016C66.236 26.489 71.6699 27.3352 73.6742 32.012C77.0147 33.3482 78.3063 35.4415 78.6181 37.7576C79.108 41.4098 77.0147 45.4184 76.6138 46.9773C76.6583 47.0664 76.6583 47.111 76.7029 47.1555C77.2374 47.4227 77.4155 47.8682 77.2374 49.338C76.7475 53.213 76.8811 55.6181 74.8767 55.0836L73.0952 58.2014C73.0061 58.5578 73.0061 58.6914 72.9615 58.9586C72.8725 59.5376 72.917 60.6956 72.917 67.0649C72.917 67.822 73.1396 68.5792 73.5405 69.1582C73.9859 69.8264 74.6095 70.4054 75.3667 70.7171C75.4113 70.7171 75.4113 70.7171 75.4557 70.7617C80.0434 72.6769 83.3393 73.924 85.7445 74.8593C91.2229 76.9973 92.0689 77.6654 92.6037 81.2731Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.658 46.9773C76.8362 45.9974 76.3907 44.7949 76.0344 43.9486C75.9899 43.815 75.9009 43.6814 75.8563 43.5032C74.2974 40.3854 70.8678 39.1383 67.5719 38.9601C59.1539 38.5148 58.3967 40.1182 55.7687 37.7131C56.5705 38.9601 56.6596 40.8753 55.4124 43.2806C54.5217 44.9731 52.8292 45.7302 51.3593 46.2201C47.5289 37.5349 49.4441 32.101 53.23 30.1858C51.9829 27.3798 51.8938 26.3999 51.8938 26.3999C51.8938 26.3999 59.9555 27.7361 62.717 27.2016C66.2357 26.489 71.6695 27.3352 73.6739 32.012C77.0143 33.3482 78.306 35.4415 78.6178 37.7576C79.1523 41.3653 77.0589 45.3739 76.658 46.9773Z",
    fill: "url(#paint5_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M87.8821 84.3909C89.9307 81.2731 89.1293 78.3335 85.8331 74.8594C91.2224 76.9973 92.113 77.6653 92.6033 81.2285C92.8261 82.8765 91.5344 84.3909 89.8416 84.3909H87.8821Z",
    fill: "#9AA2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.5851 69.1582V70.6725H54.1656V68.7128C54.3883 68.2229 54.522 67.6438 54.522 67.0648V59.2703C54.3883 59.0922 54.2547 58.9585 54.1656 58.7803V58.335C54.5665 59.0476 55.101 59.7157 55.7691 60.2502L61.871 64.526C63.2964 65.7286 65.3452 65.7732 66.815 64.6151L72.5161 59.493C72.6942 59.3148 72.9169 59.1366 73.0951 58.9585C73.0061 59.5375 73.0506 60.6956 73.0506 67.0648C73.0061 67.822 73.2288 68.5346 73.5851 69.1582Z",
    fill: "url(#paint6_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.838 92.5674C78.5615 93.7423 78.1469 94.9863 77.6631 96.023C76.3499 98.5803 74.2767 100.584 71.7197 101.897C69.0935 103.211 65.9835 103.763 62.8735 103.073C55.5479 101.552 50.8484 94.3643 52.3688 87.0387C53.8893 79.713 61.0076 74.9444 68.3333 76.534C70.9594 77.0868 73.2401 78.3999 75.1751 80.1968C78.4233 83.4449 79.8055 88.1444 78.838 92.5674Z",
    fill: "url(#paint7_linear_3552_59422)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.8378 85.9421L65.6387 88.1412L63.4396 85.9421C62.9999 85.5023 62.2669 85.4535 61.7782 85.9422C61.3384 86.382 61.2895 87.115 61.7781 87.6037L63.9772 89.8027L61.7782 92.0018C61.3383 92.4416 61.2895 93.1746 61.7782 93.6633C62.2669 94.152 62.951 94.152 63.4397 93.6633L65.6387 91.4643L67.8377 93.6633C68.2776 94.1031 69.0106 94.152 69.4993 93.6633C69.9391 93.2235 69.988 92.4904 69.4993 92.0018L67.3003 89.8027L69.4993 87.6037C69.9391 87.1639 69.988 86.4308 69.4993 85.9421C69.0107 85.4534 68.2776 85.5023 67.8378 85.9421Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3552_59422",
    x: 60.135,
    y: 28.896,
    width: 73.45,
    height: 83.3286,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3552_59422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3552_59422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_3552_59422",
    x: -2.14844,
    y: 31.2114,
    width: 70.2208,
    height: 81.0127,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3552_59422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3552_59422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_3552_59422",
    x: 12.8549,
    y: 15.3999,
    width: 101.774,
    height: 102.036,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 11
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3552_59422"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3552_59422",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3552_59422",
    x1: 82.0555,
    y1: 46.8231,
    x2: 102.107,
    y2: 46.8231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3552_59422",
    x1: 92.0061,
    y1: 69.9665,
    x2: 92.0061,
    y2: 65.3535,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3552_59422",
    x1: 35.3947,
    y1: 71.4227,
    x2: 35.3947,
    y2: 68.0366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3552_59422",
    x1: 24.6115,
    y1: 48.3369,
    x2: 45.4836,
    y2: 48.3369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3552_59422",
    x1: 20.2236,
    y1: 67.6733,
    x2: 33.8667,
    y2: 67.6733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3552_59422",
    x1: 49.2555,
    y1: 36.6908,
    x2: 78.7099,
    y2: 36.6908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3552_59422",
    x1: 63.8812,
    y1: 70.7477,
    x2: 63.8812,
    y2: 63.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E5EC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_3552_59422",
    x1: 52.0708,
    y1: 89.8027,
    x2: 79.146,
    y2: 89.8027,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3552_59422"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 120,
    height: 120,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateIllustration);
export default __webpack_public_path__ + "static/media/update_illustration.e8a04ecd0e90a786c7103a3866e4a442.svg";
export { ForwardRef as ReactComponent };